import React from 'react'

type Props = {}

const Testinomilas = (props: Props) => {
  return (
    <div className="mb-20 min-h-max w-full p-5 md:mb-5 lg:h-screen md:mt-20">
    <h1 className="p-2 text-center text-3xl font-semibold text-slate-700">Smiles Spread throughout the nation</h1>
    <p className="p-2 text-center font-light text-slate-700">Look what our previous family members have to say about our services.</p>
    <div className="grid grid-cols-1 gap-4 p-2 md:grid-cols-2 md:gap-10 lg:grid-cols-4">
      <div className="m-4 rounded-lg bg-blue-500 p-10 text-center text-2xl font-bold text-white shadow-2xl">
        <div className="space-y-4">
          <div className="h-full w-full">
            <img className="h-1/2" alt="pawsome" src="https://i.postimg.cc/LX2P86rw/12681147-11-10-removebg-preview.png" />
          </div>
          <h2 className="">Melso Butto</h2>
          <p className="text-base font-light">Bow vow Bow Bow Vow Vow Vow!!!!</p>
        </div>
      </div>
    
  
      <div className="m-4 rounded-lg bg-blue-500 p-10 text-center text-2xl font-bold text-white shadow-2xl">
        <div className="space-y-4">
          <div className="h-full w-full">
            <img className="h-1/2" alt="pawsome" src="https://i.postimg.cc/kMxnyvRQ/13818586-5337376-removebg-preview.png" />
          </div>
          <h2 className="">Dobbo</h2>
          <p className="text-base font-light">Bow vow Bow Bow Vow Vow Vow!!!!</p>
        </div>
      </div>
      <div className="m-4 rounded-lg p-10 text-center text-2xl font-bold text-blue-500 shadow-2xl">
        <div className="space-y-4">
          <div className="h-full w-full">
            <img className="h-1/2" alt="pawsome" src="https://i.postimg.cc/Y24XcdzF/cute-cat-bread-cartoon-vector-icon-illustration-animal-food-icon-concept-isolated-premium-vector-fla.png" />
          </div>
          <h2 className="">Katrina</h2>
          <p className="text-base font-light">Mew Mew Meow Meow Meowwwwww!!!</p>
        </div>
      </div>
      <div className="m-4 rounded-lg p-10 text-center text-2xl font-bold text-blue-500 shadow-2xl">
        <div className="space-y-4">
          <div className="h-full w-full">
            <img className="h-1/2" alt="pawsome" src="https://i.postimg.cc/7ZLGcWg8/cute-cat-meditation-yoga-mattress-cartoon-vector-illustration-194871-315-removebg-preview.png" />
          </div>
          <h2 className="">Billy</h2>
          <p className="text-base font-light">Mew Mew Meow Meow Meowwwwww!!!</p>
        </div>
      </div>
    </div>
  </div>
  
  )
}

export default Testinomilas